import { configureStore } from '@reduxjs/toolkit'
import bucketReducer from "../features/bucket/bucketSlice"
export const store = configureStore({
  reducer: {
    bucket: bucketReducer
  },
})